import React, { Component } from 'react';
import Square from './Square';
import {PIECE_TYPE, COLOR} from './Constans';
import BoardSquaresMap from './BoardSquaresMap';
import BoardHorizontalBand from './BoardHorizontalBand';
import BoardVerticalBand from './BoardVerticalBand';


export default class BoardView extends Component {

    constructor(props) {
      super(props);
      this.onSquareClick = this.onSquareClick.bind(this);
    }

    onSquareClick(squareKey) {
      this.props.clickSquareHandler(squareKey);
    }

    render() {
      const boardSquareMap = new BoardSquaresMap(this.props.type, this.props.whiteOnTop, this.props.draughtsType);
      const boardMapArray = boardSquareMap.getBoardSquaresMapArrayCopy();
      const position = this.props.currentPositionData.position;
      const move = this.props.currentPositionData.move;
      const sqaresInLine = boardSquareMap.getSquaresInLine();
      const squareSize = parseInt(this.props.size / sqaresInLine, 10);    
          

      let rows = [];        
      for (let r = 0; r < boardMapArray.length; r++) {
        let squares = [];
        const row = boardMapArray[r];
        for (let c = 0; c < row.length; c++) {
          const square = row[c];
          let moveSquare = false;
          let landingSquare = false;
          let piece = PIECE_TYPE.NONE;
          if (move) {
            if (square.squareKey === move.src || square.squareKey === move.dst) {
              moveSquare = true;
            } else if (move.captured.indexOf(square.squareKey) > -1) {
              piece = (move.color === COLOR.WHITE) ? PIECE_TYPE.CAPTURED_BLACK : PIECE_TYPE.CAPTURED_WHITE;
            } else if (move.landing.indexOf(square.squareKey) > -1) {
              landingSquare = true;
            }

          }
          if (position[square.squareKey]) {
            piece = position[square.squareKey];
          } 
          let selectSquare = false;
          let pickSquare = false;
          if (this.props.selectedSquares && square.squareKey !== 0 && this.props.selectedSquares.validMoves.length > 0) {
            if (this.props.selectedSquares.validMoves.indexOf(square.squareKey) > -1) {
              selectSquare = true;
            }
            if (this.props.selectedSquares.selectedSquare === square.squareKey) {
              pickSquare = true;
            }
          }
          if (r === 0 && c === 0 && this.props.editMode && this.props.chessNotation) {
            squares.push(
              <td width="1px" rowSpan="9" key="vertical_band">
                <BoardVerticalBand squareHeight={squareSize}></BoardVerticalBand>
              </td>
            );
          }
          squares.push(
            <td onClick={()=>this.onSquareClick(square.squareKey)} key={"square"+r+"_"+c}>
            <Square type={square.squareType} 
                    squareSize = {squareSize} 
                    squareKey = {square.squareKey} 
                    piece={piece} 
                    moveSquare={moveSquare} 
                    landingSquare={landingSquare}
                    selectedSquare={selectSquare}
                    pickedSquare={pickSquare}
                    editMode={this.props.editMode && !this.props.chessNotation}>
            </Square>
            </td>
          )
        }
       
        rows.push(
          <tr key={"boardRow"+r}>
            {squares}
          </tr>
        );
      }
      if (this.props.editMode && this.props.chessNotation) {
        rows.push(
          <tr key = "horizontal_band">
            <td colSpan='8'>
              <BoardHorizontalBand></BoardHorizontalBand>
            </td>
          </tr>
        )
      }
      return (
         <table cellPadding='0px' cellSpacing='0px'><tbody>
            {rows}
          </tbody></table>
      )
    }
}



// WEBPACK FOOTER //
// ./src/board/BoardView.js